import React from "react";
import {
    Box,
    Button,
    Container,
    MenuItem,
    Stack,
    TextField,
    Typography,
} from "@mui/material";
import RefreshRoundedIcon from "@mui/icons-material/RefreshRounded";
import NorthEastRoundedIcon from "@mui/icons-material/NorthEastRounded";
import ArrowOutwardRoundedIcon from "@mui/icons-material/ArrowOutwardRounded";
import {Link as RouterLink} from "react-router-dom";

export default function DashboardHeader({
    monthFilter,
    onMonthFilterChange,
    yearOptions,
    hasAccounting,
    onRefresh,
    onStartTour,
    tourOpen,
}) {
    return (
        <Box
            sx={{
                borderBottom: "1px solid",
                borderColor: "divider",
                background: "linear-gradient(135deg, rgba(255,165,0,0.12) 0%, rgba(0,0,0,0.06) 100%)",
                py: {xs: 3, md: 4},
            }}
        >
            <Container maxWidth="lg">
                <Stack
                    direction={{xs: "column", md: "row"}}
                    spacing={2}
                    alignItems={{xs: "flex-start", md: "center"}}
                    justifyContent="space-between"
                >
                    <Box>
                        <Typography variant="h4" sx={{fontWeight: 900, letterSpacing: 0.2}}>
                            Dashboard
                        </Typography>
                        <Typography
                            variant="subtitle1"
                            sx={{mt: 0.5, maxWidth: 860, display: {xs: "none", sm: "block"}}}
                        >
                            Überblick über offene Posten, Fälligkeiten und deinen monatlichen Cashflow.
                        </Typography>
                    </Box>
                    <Stack direction="row" spacing={1}>
                        <TextField
                            select
                            size="small"
                            label="Zeitraum"
                            value={monthFilter}
                            onChange={(event) => onMonthFilterChange(event.target.value)}
                            disabled={!hasAccounting}
                            helperText={!hasAccounting ? "Nur im Buchhaltungstarif" : undefined}
                            sx={{
                                minWidth: {xs: 120, sm: 160},
                                "& .MuiOutlinedInput-root": {
                                    backgroundColor: "background.paper",
                                    borderRadius: 1,
                                },
                            }}
                        >
                            <MenuItem value="current">aktueller Monat</MenuItem>
                            <MenuItem value="all">alles</MenuItem>
                            {yearOptions.map((year) => (
                                <MenuItem key={year} value={`year-${year}`}>
                                    {`Jahr ${year}`}
                                </MenuItem>
                            ))}
                        </TextField>
                        <Button
                            variant="outlined"
                            onClick={onRefresh}
                            sx={{minWidth: {xs: "48px", sm: "auto"}, px: {xs: 1, sm: 2}}}
                        >
                            <RefreshRoundedIcon/>
                            <Box component="span" sx={{display: {xs: "none", sm: "inline"}, ml: 1}}>
                                Aktualisieren
                            </Box>
                        </Button>
                        <Button
                            variant="outlined"
                            onClick={onStartTour}
                            disabled={tourOpen}
                            startIcon={<ArrowOutwardRoundedIcon/>}
                            sx={{display: {xs: "none", md: "inline-flex"}}}
                        >
                            Guided Tour
                        </Button>
                        <Button
                            variant="contained"
                            component={RouterLink}
                            to="/invoices"
                            sx={{
                                backgroundColor: "orange",
                                color: "#000",
                                fontWeight: 800,
                                "&:hover": {backgroundColor: "#ff9e1a"},
                                minWidth: {xs: "48px", sm: "auto"},
                                px: {xs: 1, sm: 2},
                            }}
                        >
                            <NorthEastRoundedIcon/>
                            <Box component="span" sx={{display: {xs: "none", sm: "inline"}, ml: 1}}>
                                Neue Rechnung
                            </Box>
                        </Button>
                    </Stack>
                </Stack>
            </Container>
        </Box>
    );
}
